import React from 'react';
import './App.css'
import AllRoutes from './routes/AllRoutes';
import { Toaster } from 'sonner';




function App() {
  return (
    <>
      <AllRoutes/> 
      <Toaster position="bottom-center"/>
    </>
  );
}

export default App;

